/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerFindAllQueryResponse, FilesControllerFindAllQueryParams, FilesControllerFindAll401, FilesControllerFindAll403 } from "../../models/filesController/FilesControllerFindAll";

function getFilesControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/files` as const }  
  return res
}

/**
 * @summary Get all files
 * {@link /api/v1/files}
 */
export async function filesControllerFindAll(params?: FilesControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerFindAllQueryResponse, ResponseErrorConfig<FilesControllerFindAll401 | FilesControllerFindAll403>, unknown>({ method : "GET", url : getFilesControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}